export interface SocialMetaOptions {
  title: string
  description?: string
  imageUrl?: string
  url?: string
}

function upsertMetaTag(attribute: 'name' | 'property', key: string, content: string) {
  if (!content.trim()) return

  const selector = `meta[${attribute}="${key}"]`
  let element = document.head.querySelector(selector) as HTMLMetaElement | null

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }

  element.setAttribute('content', content)
}

export function updateSocialMetaTags(options: SocialMetaOptions) {
  if (typeof document === 'undefined') return

  const pageUrl = options.url || window.location.href
  const description = options.description?.trim() || 'ศูนย์รวมความบันเทิงออนไลน์ มั่นคง ซื่อตรง'

  upsertMetaTag('property', 'og:type', 'website')
  upsertMetaTag('property', 'og:title', options.title)
  upsertMetaTag('property', 'og:description', description)
  upsertMetaTag('property', 'og:url', pageUrl)

  if (options.imageUrl?.trim()) {
    upsertMetaTag('property', 'og:image', options.imageUrl.trim())
    upsertMetaTag('property', 'og:image:alt', options.title)
    upsertMetaTag('name', 'twitter:card', 'summary_large_image')
    upsertMetaTag('name', 'twitter:title', options.title)
    upsertMetaTag('name', 'twitter:description', description)
    upsertMetaTag('name', 'twitter:image', options.imageUrl.trim())
  }

  upsertMetaTag('name', 'description', description)
}
